export function getQueryStringValueByName(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regexS = `[\\?&]${name}=([^&#]*)`;
  const regex = new RegExp(regexS);
  const results = regex.exec(window.location.href);
  if (results == null) {
    return '';
  }

  return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getURLParameter(name) {
  const regexResult = RegExp(`${name}=(.+?)(&|$)`).exec(location.search);
  return unescape(regexResult ? regexResult[1] : '');
}

// Regexes the domain from a URL string (excluding ports).
// Returns null if no match found.
export function getURLDomain(url) {
  const matches = url.match(/^https?:\/\/([^\/:?#]+)(?:[\/:?#]|$)/i);
  return matches && matches[1];
}
